<div class="card" [class.card--available]="card.state === 'available'"
     [class.card--resale]="card.state === 'resale'"
     [class.card--sold]="card.state === 'sold'"
     [class.card--unavailable]="card.state === 'unavailable'"
     [class.card--auction]="card.state === 'auction'"
     [class.card--prerelease]="card.state === 'prerelease'"
     [class.is-gone]="isGone"
     role="link"
     tabindex="0"
     (click)="onCardClick()"
     (keydown.enter)="onCardClick()"
     (keydown.space)="onCardClick(); $event.preventDefault()">
  <!-- Top row: one status tag on the left, favourite on the right. -->
  <div class="card-top">
    <span *ngIf="badgeLabel" class="badge" [ngClass]="badgeClass" [attr.title]="badgeTitle">{{ badgeLabel }}</span>
    <!-- Favourite (heart): top right, on everything except sold plates. -->
    <button *ngIf="showFavourite"
            type="button"
            class="card-action card-action--favourite"
            [class.is-active]="favourited"
            [attr.aria-label]="favourited ? 'Remove from favourites' : 'Add to favourites'"
            [attr.aria-pressed]="favourited"
            (click)="onFavourite($event)">
      <svg width="13" height="13" viewBox="0 0 24 24"
           [attr.fill]="favourited ? 'currentColor' : 'none'"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
      </svg>
      <span class="action-tooltip">Favourite</span>
    </button>
  </div>
  <div class="card-term">{{ card.word }}</div>
  <div class="card-plate-wrapper">
    <pla-plate [rawPlate]="card.plate"
               [showPrice]="false"
               [customClass]="'flat shaded'"
               [smallPlate]="true"
               [openModal]="false"
               [clickThrough]="false"
               [noMargin]="true"></pla-plate>
  </div>
  <!-- Flags sit under the plate so the name and plate line up across every card. -->
  <div class="card-langs" *ngIf="card.languages?.length"
       [attr.title]="languagesTitle"
       [attr.aria-label]="'Name in: ' + languagesTitle">
    <span class="fl" *ngFor="let f of flags" aria-hidden="true">{{ f.flag }}</span>
    <span class="more-langs" *ngIf="moreLanguages > 0" aria-hidden="true">+{{ moreLanguages }}</span>
  </div>
  <div class="card-info">
    <span class="card-price"
          [class.card-price--sold]="card.state === 'sold'"
          [class.card-price--muted]="card.state === 'unavailable'"
          [class.card-price--auction]="card.state === 'auction'"
          [class.card-price--tbc]="card.state === 'prerelease' && card.price == null"
          [attr.title]="card.historyNote || null">{{ formatPrice() }}</span>

    <span class="card-actions">
      <!-- Notify — legacy parity: only on plates you can't buy right now.
           Same notify list the account Alerts page reads. -->
      <button *ngIf="showNotify"
              type="button"
              class="notify-btn"
              [class.is-active]="tracked"
              [attr.aria-pressed]="tracked"
              [attr.aria-label]="tracked ? 'Stop notifying me about this plate' : (card.state === 'prerelease' ? 'Notify me when this plate goes on sale' : 'Notify me if this plate becomes available')"
              (click)="onTrack($event)">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        {{ notifyLabel }}
      </button>

    </span>
  </div>
</div>
